import {Injectable} from '@angular/core';
import {PartnerModel} from '../../../api/model/partner.model';
import {PartnerConverter} from '../../../api/converter/partner.converter';
import {
    AbstractDataServiceDtoAdapter
} from '../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter';
import {PartnerDataService} from './partnerData.service';

@Injectable({ providedIn: 'root' })
export class PartnerDataServiceAdapter extends
    AbstractDataServiceDtoAdapter<PartnerModel, PartnerConverter> {
    constructor(dataService: PartnerDataService, converter: PartnerConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): PartnerModel {
        return new PartnerModel();
    }
}
